"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastConstants = exports.SHOW_TOAST = exports.HIDE_TOAST = exports.CLEAR_TOASTS = void 0;
// Action Types
var SHOW_TOAST = exports.SHOW_TOAST = 'zola/toasts/SHOW_TOAST';
var HIDE_TOAST = exports.HIDE_TOAST = 'zola/toasts/HIDE_TOAST';
var CLEAR_TOASTS = exports.CLEAR_TOASTS = 'zola/toasts/CLEAR_TOASTS';
var ToastConstants = exports.ToastConstants = /*#__PURE__*/function (ToastConstants) {
  ToastConstants["POSITIVE"] = "POSITIVE";
  ToastConstants["NEGATIVE"] = "NEGATIVE";
  return ToastConstants;
}({});